// Blog posts — data lives in blog-posts.json (also consumed by scripts/prerender.js).
import data from "./blog-posts.json";

export const BLOG_POSTS = data.posts;
export const BLOG_ORDER = data.order;
